import {
  Component,
  EventEmitter,
  HostBinding,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { Params } from '@angular/router';
import { ButtonType, Size } from '../../interfaces/size';

@Component({
  selector: 'un-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.less'],
  standalone: false,
})
export class ButtonComponent implements OnInit {
  @Input() disabled?: boolean | null;
  @Input() size: Size = 'medium';
  @Input() type: ButtonType = 'default';
  @Input() link?: string | string[] | null = null;
  @Input() queryParams?: Params;
  @Input() @HostBinding('class.btn-fullwidth') fullwidth: boolean;
  @Output() btnClick = new EventEmitter<void>();

  isExternal: boolean;

  ngOnInit() {
    const regx = /((http|https):\/\/(?!www.univacity.com)[\w./\-=?#]+)/;
    if (typeof this.link === 'string' && regx.test(this.link))
      this.isExternal = true;
  }
}
